import style from './style.scss';
import chromeIcon from '../../assets/browsers/chrome.svg';
import safariIcon from '../../assets/browsers/safari.svg';

const UnsupportedBrowsers = () => (
  <div className={style.wrapper}>
    <h1 className={style.header}>You are seeing this page because you are using an unsupported browser. Currently, we support the following browsers:</h1>
    <div className={style.browser}>
      <a className={style.browserLink} href="https://www.google.com/chrome" target="_blank" rel="noopener noreferrer">
        <img src={chromeIcon} alt="Google Chrome" />
        <p>Google Chrome <br /><span>(Latest Version)</span></p>
      </a>
    </div>
    <div className={style.browser}>
      <a className={style.browserLink} href="https://www.apple.com/safari" target="_blank" rel="noopener noreferrer">
        <img src={safariIcon} alt="Safari" />
        <p>Safari <br /><span>(Latest Version)</span></p>
      </a>
    </div>
  </div>
);

export default UnsupportedBrowsers;



// WEBPACK FOOTER //
// ./components/unsupported-browsers/index.js